<template>
    <div class="container">
        <tab-list :tabList="tabBar" @tabClick="tabClick" :cur="activeTab" :noBg="true"></tab-list>
        <div class="scroll">
            <scroll v-if="meetingOrderList.length" :data="meetingOrderList"
            :allLoaded="allLoaded"  @pulldown="loadData" @loadUp="loadup" >
                <div class="list_item" @click="toDetail(item)" v-for="(item,index) in meetingOrderList" :key="index">
                    <p class="item_top">
                        <img src="@/assets/images/icon_quotation_mark.png" />
                        <span>{{item.theme}}</span>
                    </p>
                    <div class="item_center">
                        <img :src="item.imageUrl" class="item_center_left">
                        <div class="item_center_right">
                            <p><span>地点:</span>{{item.roomName}}</p>
                            <p><span>日期:</span>{{item.payDate}} {{item.payDate|week}}</p>
                            <p><span>时间:</span>{{item.beginTime}} - {{item.endTime}}</p>
                        </div>
                    </div>
                    <div class="item_bottom">
                        <template v-if="item.status == 0">
                            <span class="cancel_btn" @click.stop="cancelOrder(item.id)">取消订单</span>
                            <span class="qr_btn" @click.stop="getTenantQrCode(item)"><img src="@/assets/images/icon_member_qrcode.png" />门禁码</span>
                        </template>
                        <span v-else class="cancel_btn">查看详情</span>
                    </div>
                    <span v-if="item.status == 0" class="appoint_status">已预订</span>
                    <img class="cancel_icon" v-else-if="item.status == 1" src="@/assets/images/icon_audit_completed.png" />
                    <img class="cancel_icon" v-else src="@/assets/images/icon_canceled.png" />
                </div>
            </scroll>
            <no-message v-if="!meetingOrderList.length && loaded"></no-message>
        </div>
        <!-- 门禁码 -->
        <mt-popup  v-model="qrcode_box" position="center">
            <div class="qrcode_box">
                <div class="qrcode_top">
                    <p class="qr_title">门禁码</p>
                    <div class="QRCode" ref="qrCodeUrl"></div>
                    <p class="qr_desc">刷码建议距离10cm左右</p>
                    <!-- <p class="qr_code">FK-021-00000043</p> -->
                </div>
                <img class="close" @click="qrcode_box = false" src="@/assets/images/icon_popup_close.png" />
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import tabList from '@/components/tabbar';
import Scroll from '@/components/scroll';
import NoMessage from '@/components/nomessage';
import {getMeetingOrderListSmart,cancelMeetingOrderSmart,desEncrypt} from "@/utils/api";
import util from "@/utils/util";
import QRCode from 'qrcodejs2';
export default {
  name: "myCoupon",
  components: {
      tabList,
      Scroll,
      NoMessage
  },
  computed: {
    ...mapState({
      common: state => state.common,
    }),
    activeWeekDay(){
        return util.getWeek(this.orderInfo.payDate)
    }
  },
  data() {
    return {
        qrcode_box:false,
        timestamp:'',
        qrcodeTool:'',
        tabBar:['全部', '已预订', '已完成'],
        type:0,//1完成,0已预订
        activeTab:0,
        pageNo:1,
        meetingOrderList:[1],
        loaded: true,
        allLoaded: true,
    }
  },
  filters: {
      date: function(data) {
        if (data) {
          return data.split('-').join('.')
        }
      },
      week:function(data) {
          return util.getWeek(data)
      }
  },
  activated(){
    this.pageNo = 1;
    this.getMeetingOrderListSmart();
  },
  methods: {
       getMeetingOrderListSmart(){
        util.showLoading()
         var param = {
          userId: this.common.userId,
          pageNo: this.pageNo,
          pageSize: 10
        }
        if(this.activeTab == 1){
            param.type = 0
        }else if(this.activeTab == 2){
            param.type = 1
        }
       getMeetingOrderListSmart(param).then(res => {
           console.log(res)
            this.loaded =true;
            util.hideLoading()
            if (res.res && res.res.code === 10000 && res.body) {
                this.timestamp =res.res.timestamp;
                var list = res.body.meetingOrderList || [];
                if (this.pageNo === 1) {
                    this.meetingOrderList =  list;
                } else {
                    this.meetingOrderList = this.meetingOrderList.concat(list)
                }
                if(list.length%10==0){
                    this.allLoaded =false
                }else{
                    this.allLoaded =true;
                }
            }
        });
     },
    //获取二维码数据
    getTenantQrCode(item) {
        util.showLoading()
        let content = {
            uid:item.id,
            operationType: "3", //1门禁,2访客，3.会议室
            userId:item.userId,
            marketId:item.marketId,
            timestamp: this.timestamp.toString()
        };
        desEncrypt(content).then(res => {
            util.hideLoading()
            this.qrcode_box = true;
            this.creatQrCode(res);
        })
    },
    //js生成二维码
    creatQrCode(dic) {
      if(!this.qrcodeTool){
        var wh =document.body.clientWidth;
        var w =170*wh/375;
        var h =170*wh/375;
        this.qrcodeTool = new QRCode(this.$refs.qrCodeUrl, {
          text: dic ,
          width: w,
          height: h,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.M
        })
      }else{
        this.qrcodeTool.clear(); // 清除代码
        this.qrcodeTool.makeCode(dic); // 生成另外一个二维码
      }
    },
    cancelOrder(id){
        util.showModal('', '确定要取消该订单吗？', true, '确定', () => {
            util.showLoading()
            cancelMeetingOrderSmart({orderId:id}).then(res => {
            if (res.res && res.res.code === 10000) {
                util.hideLoading()
                util.showToast("已取消")
                setTimeout(() => {
                    this.pageNo = 1;
                    this.getMeetingOrderListSmart();
                }, 1000);
            }else{
                util.showToast(res.res.msg)
            }
            });
        });
    },
     toDetail(item){
        this.$router.push(`/smartOffice/meetingAppointDetail?id=${item.id}&meetingRoomId=${item.meetingRoomId}`)
     },
    tabClick (val) {
      this.activeTab = val;
      this.pageNo = 1;
      this.getMeetingOrderListSmart();
    },
    loadup () {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getMeetingOrderListSmart();
    },
    loadData () {
      this.pageNo = 1;
      this.getMeetingOrderListSmart();
    },

  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
    height: 100vh;
    position: relative;
    background:#eee;
    .flex(column);
    .scroll {
        flex: 1;
        height: 500px;
    }
}
.list_item{
    background:rgba(255,255,255,1);
    border-radius:8px;
    margin:20px;
    padding:28px;
    position: relative;
    .item_top{
        .flex();
        height:44px;
        align-items: center;
        margin-bottom:40px;
        img{
            width:24px;
            height:22px;
            margin-right:14px;
        }
        span{
            font-size:32px;
            font-weight:bold;
            color:rgba(51,51,51,1);
        }
    }
    .item_center{
        .flex();
        margin-bottom:40px;
        .item_center_left{
            width:216px;
            height:162px;
            border-radius: 8px;
            margin-right:28px;
        }
        .item_center_right{
            flex:1;
            p{
                font-size:28px;
                color:rgba(51,51,51,1);
                line-height:40px;
                margin-bottom:14px;
                span{
                    font-size:28px;
                    color:rgba(153,153,153,1);
                    line-height:40px;
                    display: inline-block;
                    margin-right:10px;
                }
            }
        }
    }
    .item_bottom{
        .flex();
        justify-content: flex-end;
        span{
            margin-left:20px;
        }
        .cancel_btn{
            width:160px;
            height:68px;
            border-radius:8px;
            border:2px solid rgba(218,218,218,1);
            text-align:center;
            line-height: 64px;
            box-sizing:border-box;
            color:rgba(102,102,102,1);
        }
        .qr_btn{
            .flex();
            justify-content: center;
            align-items: center;
            width:168px;
            height:68px;
            background:rgba(23,64,218,1);
            border-radius:8px;
            line-height: 68px;
            font-size:28px;
            color:#fff;
            img{
                width:28px;
                height:28px;
                margin-right:8px;
            }
        }
    }
    .appoint_status{
        position: absolute;
        right:28px;
        top:28px;
        font-size:26px;
        color:rgba(253,152,56,1);
        line-height:36px;
        font-size:28px;
    }
    .cancel_icon{
        position: absolute;
        right:24px;
        top:24px;width:120px;
        height:120px;
    }
}
.qrcode_box{
    .flex(column);
    align-items: center;
    justify-content: center;
    .qrcode_top{
        .flex(column);
        align-items: center;
        justify-content: center;
        width:670px;
        background:#fff;
        border-radius:16px;
        padding-bottom:120px;
        .qr_title{
            height:50px;
            font-size:36px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            line-height:50px;
            margin:100px 0 80px;
        }
        .qr_desc{
            height:40px;
            font-size:28px;
            color:rgba(255,126,30,1);
            line-height:40px;
            margin-top:48px;
        }
        .QRCode{
            width:340px;
            height:340px;
        }
        .qr_code{
            height:40px;
            font-size:28px;
            color:rgba(51,51,51,1);
            line-height:40px;
            margin-bottom:28px;
        }
    }
    .close{
        width:68px;
        height:68px;
        margin-top:40px;
    }
}
.mint-popup{background:transparent !important;transition:0s !important;}
</style>